import { useQueryClient } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { useIoContext, useOverlayContext } from "../../../../../../../../contexts";
import { QueryKeys } from "../../../../../../../../hooks/reactQuery/queryKeys";
import { useMutationState } from "../../../../../../../../hooks/reactQuery/useMutationState";
import { makeFailure, makeSuccess, sendErrReport } from "../../../../../../../../infra/utils";
import { legalTermsModel } from "../../../../../../../../models";
import { useAppConfig, useStoreActions } from "../../../../../../../../store/store-context";
import { NameThisDocumentModalError } from "../../../NameThisDocumentModal/NameThisDocumentModal";
export const useUploadLegalTerms = _ref => {
  let {
    onSettled: _onSettled,
    errorToastTestId
  } = _ref;
  const {
    api
  } = useStoreActions();
  const queryClient = useQueryClient();
  const overlayContext = useOverlayContext();
  const {
    generateUniqueId
  } = useAppConfig();
  const {
    uploadFileToCloudStorage
  } = useIoContext();
  const {
    mutateAsync: uploadLegalTerms,
    isLoading
  } = useMutationState({
    mutationFn: async _ref2 => {
      let {
        file,
        newFileName
      } = _ref2;
      try {
        const {
          fileId,
          url
        } = await api.business.getLegalTermsUploadURL();
        await uploadFileToCloudStorage(url, file, {
          'content-type': 'application/pdf'
        });
        const uploadedLegalTerms = legalTermsModel.makePdfLegalTerms({
          name: newFileName,
          pdfUniqueName: fileId
        }, generateUniqueId);
        await api.business.createLegalTerms(uploadedLegalTerms);
        return makeSuccess(uploadedLegalTerms);
      } catch (error) {
        var _error$response;
        if (error instanceof AxiosError && ((_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status) === 400 && NameThisDocumentModalError[error.response.data.error]) {
          return makeFailure(error.response.data.error);
        }
        return makeFailure(error);
      }
    },
    onSettled: async result => {
      if (result !== null && result !== void 0 && result.success) {
        await queryClient.invalidateQueries({
          queryKey: [QueryKeys.LegalTerms]
        });
        _onSettled(result.data);
      } else {
        if (!NameThisDocumentModalError[result === null || result === void 0 ? void 0 : result.error]) {
          const message = 'An unknown error has occurred.';
          sendErrReport(result === null || result === void 0 ? void 0 : result.error);
          overlayContext.showErrorToast(message, errorToastTestId);
        }
        _onSettled(undefined);
      }
    }
  });
  return {
    uploadLegalTerms,
    isLoading
  };
};